var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.seconds &&  _vm.countdown != '00:00:00')?_c('span',[_vm._v(_vm._s(_vm.countdown))]):_vm._e(),(_vm.mensaje && _vm.countdown == '00:00:00')?_c('span',{staticStyle:{"font-size":".8rem"}},[_vm._v(_vm._s(_vm.mensaje))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }